export enum SmevMonitoringStatusesEnum {
  NEW = 'NEW',
  SENT = 'SENT',
  FAILED = 'FAILED',
  FAULT = 'FAULT',
  SUCCESS = 'SUCCESS',
  PROCESSED = 'PROCESSED',
  QUEUED = 'QUEUED',
  REJECTED = 'REJECTED',
}
